
import { Message } from "./message-item";
import { nanoid } from "nanoid";

export const WELCOME_MESSAGE: Message = {
  id: "welcome-message",
  content: "Velkommen til Klara – et verktøy for jobbveiledere! For å ivareta personvern og datasikkerhet ber vi om at du ikke legger inn personopplysninger i denne samtalen.",
  role: "assistant",
  timestamp: new Date()
};

export const createUserMessage = (content: string): Message => ({
  id: nanoid(),
  content,
  role: "user",
  timestamp: new Date()
});

export const createAssistantMessage = (content: string): Message => ({
  id: nanoid(),
  content,
  role: "assistant",
  timestamp: new Date()
});

export const createSystemMessage = (content: string): Message => ({
  id: nanoid(),
  role: "system",
  content,
  timestamp: new Date()
});
